module.exports = __webpack_public_path__ + "static/media/moraine-31.70ef6ad1.jpg";